import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarRange, Landmark, FileSignature, Tag, PackagePlus, LogOut } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Copilot } from "@/components/Copilot";
import { LOGO_URL } from "@/data/content";

const TABS = [
  { to: "/portal", label: "Dashboard", icon: LayoutDashboard },
  { to: "/portal/reservations", label: "Reservations", icon: CalendarRange },
  { to: "/portal/pricing", label: "Pricing", icon: Tag },
  { to: "/portal/upsells", label: "Upsells", icon: PackagePlus },
  { to: "/portal/settlements", label: "Settlements", icon: Landmark },
  { to: "/portal/payouts", label: "Payouts", icon: Landmark },
  { to: "/portal/contracts", label: "Agreements", icon: FileSignature },
];

export const PortalShell = ({ title, children }) => {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid="portal-shell" className="min-h-screen bg-ink">
      <Navbar />
      <div className="border-b border-black/[0.08] bg-white/80 pt-[92px] backdrop-blur">
        <div className="container-x flex flex-wrap items-center justify-between gap-3 py-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="" className="h-8 w-auto sm:hidden" />
            <div>
              <p className="eyebrow">Partner Portal</p>
              <h1 className="font-display text-xl font-extrabold tracking-tight text-offwhite" data-testid="portal-title">{title}</h1>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden text-xs text-muted sm:block">{user?.email}</span>
            <button onClick={async () => { await logout(); navigate("/"); }} className="btn-ghost !px-4 !py-2 !text-xs" data-testid="portal-signout-btn">
              <LogOut size={13} /> Sign out
            </button>
          </div>
        </div>
        <nav className="container-x flex gap-1 overflow-x-auto pb-0" aria-label="Portal">
          {TABS.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              data-testid={`portal-tab-${label.toLowerCase()}`}
              className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold transition-colors ${
                pathname === to ? "border-aqua text-offwhite" : "border-transparent text-muted hover:text-offwhite"
              }`}
            >
              <Icon size={15} /> {label}
            </Link>
          ))}
        </nav>
      </div>
      <main className="container-x py-8 pb-24">{children}</main>
      <Copilot audience="partner" />
    </div>
  );
};
